(function () {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeConfigDataStore', 
		[
			'$q', 
			'smbContentTypeConfigService',
			'smbStatusConfigService',
			'smbContentTypeTagTypeConfigDataStore',
			ContentTypeConfigDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeConfigDataStore
	 * 
	 * @description
	 * Data store that manages state for the content type configuration section.
	 */
	function ContentTypeConfigDataStore($q, smbContentTypeConfigService, smbStatusConfigService, smbContentTypeTagTypeConfigDataStore) {

		var _contentType;
		var _newContentType = {
			FolderName: '',
			IconName: ''
		};

		return {
			/**
			 * @ngdoc method
			 * @name smbContentTypeConfigDataStore.getContentType
			 * @methodOf smb-app.smbContentTypeConfigDataStore
			 * @kind function
			 * 
			 * @description
			 * Loads the data store with a content type by id
			 * 
			 * @param {String} groupId Id of the content type group the type belongs to
			 * @param {String} id The content type id
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the content type being loaded
			 */
			getContentType: getContentType,
			
			/**
			 * @ngdoc method
			 * @name smbContentTypeConfigDataStore.saveContentType
			 * @methodOf smb-app.smbContentTypeConfigDataStore
			 * @kind function
			 * 
			 * @description
			 * Saves changes to the current content type. Creates it if it is a new one and
			 * updates it if it is an existing one.
			 * 
			 * @param {String} groupId The id of the content type group it belongs to
			 * @param {ContentType} contentType The content type object to save.
			 * 
			 * @returns {Deferred} Returns a promise that resolves to the saved content type
			 */
			saveContentType: saveContentType,

			/**
			 * @ngdoc property
			 * @name smbContentTypeConfigDataStore.contentType
			 * @propertyOf smb-app.smbContentTypeConfigDataStore
			 * @kind property
			 * 
			 * @description
			 * Returns the current content type
			 */
			get contentType() { return _contentType; }
		};

		function getContentType(groupId, id) {
			if (!id) {
				_contentType = angular.copy(_newContentType);
				return $q.resolve(_contentType);
			}

			return smbContentTypeConfigService.getContentType(groupId, id)
				.then(function (response) {
					_contentType = response;
					return response;
				});
		}

		function saveContentType(groupId, contentType) {
			var folder = null;
			if (contentType.FolderId) {
				return smbContentTypeConfigService.updateContentType(groupId, contentType)
					.then(function(res) {
						_contentType = res;
						return res;
					});
			} else {
				return smbContentTypeConfigService.addContentType(groupId, contentType)
					.then(function(res) {
						_contentType = res;
						return res;
					})
					.then(function loadStatuses() {
						return smbStatusConfigService.getStatuses(groupId);
					})
					.then(function mapStatuses(statuses) {
						return smbContentTypeTagTypeConfigDataStore.setTagTypes(_contentType.FolderId, statuses);
					});
			}
		}
	}

}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/contentTypeConfigDataStore.js
// module id = 106
// module chunks = 1